import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";

import { toast } from "react-toastify";
import {
  unitConstModel,
  productTypeConstModel,
} from "../../../constant/ConstantList";

const ProductForm = (props) => {
  const frmRef = useRef({});

  const [close, setClose] = useState(false);
  const [cropclose, setCropClose] = useState(false);
  
  const [productData, setProductData] = useState([]);
  const [packagingProductData, setpackagingProductData] = useState([]);
  const [inputProductData, setinputProductData] = useState([]);
  const [packagingProductId, setpackagingProductId] = useState([]);
  const [inputProductId, setinputProductId] = useState([]);
  const [packSizeUnitId, setpackSizeUnitId] = useState();

  const [packagingProductName, setpackagingProductName] = useState([]);
  const [inputProductName, setinputProductName] = useState([]);
  const [minimumQtyText, setminimumQtyText] = useState(
    "Minimum Notifier Quantity"
  );
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const offset = currentPage * itemsPerPage;
  const displayedItems =
    productData && productData.slice(offset, offset + itemsPerPage);

  const handleItemsChange = (e) => {
    const value = parseInt(e.target.value);
    if (value > 0) {
      setItemsPerPage(value);
    } else {
      setItemsPerPage(10);
    }
  };

  const [productItemType_id, setProductItemType_id] = useState([]);
  const [productItemType_popid, setProductItemType_popid] = useState([]);

  const [productSubItemId, setProductSubItemId] = useState([]);

  const [unitId, setUnitId] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [unitFilterList, setUnitFilterList] = useState([]);
  const [productItemTypeList, setProductItemTypeList] = useState([]);
  const [productsubitemList, setProductsubitemList] = useState([]);

  const [productsubitemfilterList, setProductsubitemfilterList] = useState([]);

  const cropTypeOnchangedHandler = (event) => {
    event.preventDefault();

    var productType = event.target.value;
    setProductItemType_id(event.target.value);
    setProductsubitemfilterList([]);
    const ptyList = productItemTypeList.filter(
      (item) => ((parseInt(item.productItemTypeId) === parseInt(productType))&&item.isService==1)
    );
  console.log("ptyList",ptyList)
     if(ptyList&&ptyList.length>0)
     {
      var unit = unitList.filter(
            (item) =>
              item.unitTypeId == unitConstModel.NumberUnitTypeId ||
              item.unitTypeId == unitConstModel.weightUnitTypeId ||
              item.unitTypeId == unitConstModel.volumnUnitTypeId ||
              item.unitTypeId == unitConstModel.areaUnitTypeId
          );
          setUnitFilterList(unit);
     }else
     {
       var unit = unitList.filter(
            (item) =>
              item.unitTypeId == unitConstModel.NumberUnitTypeId ||
              item.unitTypeId == unitConstModel.weightUnitTypeId ||
              item.unitTypeId == unitConstModel.volumnUnitTypeId
          );
           
          setUnitFilterList(unit);
        }

    const productsubitemfilterList = productsubitemList.filter(
      (item) => parseInt(item.productTypeId) === parseInt(productType)
    );

    console.log("productsubitemfilterList", productsubitemfilterList);
    setProductsubitemfilterList(productsubitemfilterList);

    if (productData.length > 0) {
      var boxSubtype = productData.filter(
        (item) => item.productSubTypeName.toLowerCase() == "box"
      );

      setpackagingProductData(boxSubtype);
    }
  };

  const { sendRequest: getUnit } = useHttp();

  const getUnitDetail = () => {
    getUnit(
      {
        url: `/api/units?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
        
          // var unit = res.filter(
          //   (item) =>
          //     item.unitTypeId == unitConstModel.NumberUnitTypeId ||
          //     item.unitTypeId == unitConstModel.weightUnitTypeId ||
          //     item.unitTypeId == unitConstModel.volumnUnitTypeId
          // );
          setUnitList(res);
          setUnitFilterList(res);
        }
      }
    );
  };

  useEffect(() => {
    getUnitDetail();
  }, [getUnit]);

  const { sendRequest: getProductitemtypes } = useHttp();

  const getproductitemDetail = () => {
    getProductitemtypes(
      {
        url: "/api/productitemtypes/",
      },
      (res) => {
        if (res) {
          
          setProductItemTypeList(res);
        }
      }
    );
  };

  useEffect(() => {
    getproductitemDetail();
  }, [getProductitemtypes]);

  const { sendRequest: getproductsubitem } = useHttp();

  const getproductsubitemDetail = () => {
    getproductsubitem(
      {
        url: `/api/productsubitem/?orgId=${localStorage.getItem(
          "orgId"
        )}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
         

          setProductsubitemList(res);

          setProductsubitemfilterList([]);
      

          if (productItemType_id != "--Select Product Item Type--") {
            const productsubitemfilterList = res.filter(
              (item) =>
                parseInt(item.productTypeId) === parseInt(productItemType_id)
            );

            

            setProductsubitemfilterList(productsubitemfilterList);
          }
        }
      }
    );
  };

  useEffect(() => {
    getproductsubitemDetail();
  }, [getproductsubitem]);

  const { sendRequest: getproduct } = useHttp();

  const getProductDetail = () => {
    getproduct(
      {
        url: "/api/product/",
      },
      (res) => {
        if (res) {
          //console.log("product",res);
          setProductData(res);

          if (res.length > 0) {
            var boxSubtype = res.filter(
              (item) => item.productSubTypeName.toLowerCase() == "box"
            );

            setpackagingProductData(boxSubtype);
          }
        }
      }
    );
  };

  useEffect(() => {
    getProductDetail();
  }, [getproduct]);

  const { sendRequest: postCrop } = useHttp();

  const cropsubmitHandler = (e) => {
    e.preventDefault();

    const data = {
      productSubTypeName: frmRef.current.productItemSubtypeName.value.trim(),
      productSubType: frmRef.current.productItemSubtypeNo.value.trim(),
      productTypeId: frmRef.current.productItemType_popid.value,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: new Date(),
      serviceId: props.sId, 
    };

    postCrop(
      {
        url: "/api/productsubitem/",
      
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(data);
        getproductsubitemDetail();
        frmRef.current.productItemType_popid.value =
          "--Select Product Item Type--";
        frmRef.current.productItemSubtypeNo.value = "";
        frmRef.current.productItemSubtypeName.value = "";
        setProductItemType_popid("--Select Product Item Type--");
        setCropClose(false);
      },
      (error) => {
        toast.error(error);
      }
    );
  };

  const { sendRequest: postCropType } = useHttp();

  const productItemTypesubmitHandler = (e) => {
    e.preventDefault();

    const data = {
      productTypeName: frmRef.current.productTypeName.value.trim(),
      productTypeNo: frmRef.current.productTypeNo.value.trim(),
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: new Date(),
    };
    
    postCrop(
      {
        url: "/api/productitemtypes/",
     
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(data);
        getproductitemDetail();
        setClose(false);
        frmRef.current.productTypeName.value = "";
        frmRef.current.productTypeNo.value = "";
      },
      (error) => {
        toast.error(error);
      }
    );
  };

  const { sendRequest: postCropVariety } = useHttp();

  const productsubmitHandler = (e) => {
    e.preventDefault();
    var productCode = "";
    //console.log("productsubitemList",productsubitemList);
    if (productData.length > 0) {
      //console.log("productCode Start");
      var pCount = productData.filter(
        (item) =>
          parseInt(item.productSubTypeId) ==
          parseInt(frmRef.current.productSubItemId.value)
      ).length;
      var itemtype = productItemTypeList.filter(
        (item) =>
          parseInt(item.productItemTypeId) == parseInt(productItemType_id)
      );
      var itemsubtype = productsubitemList.filter(
        (item) => parseInt(item.productSubTypeId) == parseInt(productSubItemId)
      );


      var countStr = "0000" + (pCount + 1);
      productCode =
        itemtype[0].productTypeNo +
        itemsubtype[0].productSubType +
        countStr.substr(countStr.length - 4);
      
    }

    var gradeId;
    var varietyId;
    var packsize = 0;
    var packsizeUnitId;
    var packagingTypeId1;
    var inputproductId1;
    var minimumqty = frmRef.current.minimumQty.value.trim();

    if (
      productTypeConstModel.finishProductId == productItemType_id ||
      productTypeConstModel.packagingProductId == productItemType_id
    ) {
      packsize = frmRef.current.packSize.value.trim();

      packsizeUnitId = packSizeUnitId;
      if ((inputProductId || 0) > 0) {
        inputproductId1 = inputProductId;
        var productItemList = productData.filter(
          (item) => item.productId == inputProductId
        );
        if (productItemList.length > 0) {
          var productItem = productItemList[0];
          gradeId = productItem.gradeId;
          varietyId = productItem.varietyId;
        }
      }

      if ((packagingProductId || 0) > 0) {
        packagingTypeId1 = packagingProductId;
        var productitemlist = productData.filter(
          (item) => item.productId == packagingProductId
        );
        if (productItemList.length > 0) {
          var productItem = productItemList[0];
          packsize = productItem.packsize;
          packsizeUnitId = productItem.packsizeUnitId;
        }
      }
    }
    const data = {
      productName: frmRef.current.productName.value.trim(),
      itemId: productCode,
      productSubTypeId: productSubItemId,
      unitId: frmRef.current.unitId.value,
      gradeId: gradeId,
      varietyId: varietyId,
      packsize: packsize,
      packsizeUnitId: packsizeUnitId,
      packagingTypeId: packagingTypeId1,
      inputproductId: inputproductId1,
      minimumQty: minimumqty,
      status: 1,
      orgId: parseInt(localStorage.getItem("orgId")),
      createdBy: parseInt(localStorage.getItem("id")),
      createdDate: new Date(),
       serviceId: props.sId, 
    };
 
    postCrop(
      {
        url: "/api/product/",
   
        method: "POST",
        body: data,
      },
      (data) => {
        toast.success(data);
        props.addForm(close);
      },
      (error) => {
        toast.error(error);
      }
    );
  };

  return (
    <>
      <div className="modal fade" id="modal-sm-producttype">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Product Type</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form
              style={{ margin: "10px" }}
              onSubmit={productItemTypesubmitHandler}
            >
              <div className="modal-body">
                <div className="form-group">
                  <label>Product Type Name</label>

                  <input
                    type={"text"}
                    id={"productTypeName"}
                    required
                    ref={(el) => (frmRef.current["productTypeName"] = el)}
                    className="form-control"
                  />
                </div>
                <div className="form-group">
                  <label>Product Type No</label>

                  <input
                    type={"text"}
                    id={"productTypeNo"}
                    required
                    ref={(el) => (frmRef.current["productTypeNo"] = el)}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button className="btn btn-primary">Add</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade" id="modal-sm-productsubtype">
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Product Subtype</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={cropsubmitHandler}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Product Item Type Name</label>
                  <select
                    id="productItemType_popid"
                    className="form-control"
                    ref={(el) => (frmRef.current["productItemType_popid"] = el)}
                    value={productItemType_popid}
                    onChange={(e) => {
                      setProductItemType_popid(e.target.value);
                    }}
                    required
                  >
                    <option value="">Select Product Item Type</option>
                    {productItemTypeList &&
                      productItemTypeList.map((x) => (
                        <option
                          key={x.productItemTypeId}
                          productItemType-id={x.productItemTypeId}
                          value={x.productItemTypeId}
                        >
                          {x.productTypeName}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Product Item Subtype Name</label>
                  <input
                    type={"text"}
                    id={"productItemSubtypeName"}
                    required
                    ref={(el) =>
                      (frmRef.current["productItemSubtypeName"] = el)
                    }
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label>Product Item Subtype No</label>
                  <input
                    type={"text"}
                    id={"productItemSubtypeNo"}
                    required
                    ref={(el) => (frmRef.current["productItemSubtypeNo"] = el)}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="modal-footer justify-content-between">
                <button className="btn btn-primary">Add</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={productsubmitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Product Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>product Type Name</label>
                        <button
                          type="button"
                          className="btn-primary"
                          data-toggle="modal"
                          data-target="#modal-sm-producttype"
                        >
                          +
                        </button>

                        <select
                          id="productItemType_id"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["productItemType_id"] = el)
                          }
                          value={productItemType_id}
                          onChange={cropTypeOnchangedHandler}
                          required
                        >
                          <option value="">Select Product Type</option>
                          {productItemTypeList &&
                            productItemTypeList.map((x) => (
                              <option
                                key={x.productItemTypeId}
                                productItemType-id={x.productItemTypeId}
                                value={x.productItemTypeId}
                              >
                                {x.productTypeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Product Subtype </label>
                        <button
                          type="button"
                          className="btn-primary"
                          data-toggle="modal"
                          data-target="#modal-sm-productsubtype"
                        >
                          +
                        </button>

                        <select
                          id="productSubItemId"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["productSubItemId"] = el)
                          }
                          required
                          value={productSubItemId}
                          onChange={(e) => {
                            //console.log("e.target.value",e.target.value);
                            setProductSubItemId(e.target.value);
                            var inputProductData = productData.filter(
                              (item) =>
                                item.productSubTypeId == e.target.value &&
                                parseInt(item.packagingTypeId || 0) == 0
                            );

                            setinputProductData(inputProductData);
                          }}
                        >
                          <option value="">Product Sub Type</option>
                          {productsubitemfilterList &&
                            productsubitemfilterList.map((x) => (
                              <option
                                key={x.productSubItemId}
                                productSubItem-id={x.productSubItemId}
                                value={x.productSubTypeId}
                              >
                                {x.productSubTypeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Product Name </label>

                        <input
                          type="text"
                          required
                          id="productName"
                          className="form-control"
                          ref={(el) => (frmRef.current["productName"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        {productTypeConstModel.finishProductId ==
                          productItemType_id ||
                        productTypeConstModel.seedProductId ==
                          productItemType_id ? (
                          <label>Packaging Type </label>
                        ) : (
                          <b>&nbsp;</b>
                        )}
                        {productTypeConstModel.finishProductId ==
                          productItemType_id ||
                        productTypeConstModel.seedProductId ==
                          productItemType_id ? (
                          <select
                            id="productSubItemId"
                            className="form-control"
                            ref={(el) =>
                              (frmRef.current["packagingProductId"] = el)
                            }
                            value={packagingProductId}
                            required
                            onChange={(e) => {
                              var packagingProduct =
                                e.target.options[e.target.selectedIndex].text;
                              var inputproduct = inputProductName;

                              frmRef.current.productName.value =
                                packagingProduct + " " + inputproduct;

                              setpackagingProductName(packagingProduct);

                              setpackagingProductId(e.target.value);
                            }}
                          >
                            <option value="">Packaging Type</option>
                            {packagingProductData &&
                              packagingProductData.map((x) => (
                                <option
                                  key={x.productId}
                                  product-id={x.productId}
                                  value={x.productId}
                                >
                                  {x.productName}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <b>&nbsp;</b>
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        {productTypeConstModel.finishProductId ==
                          productItemType_id ||
                        productTypeConstModel.seedProductId ==
                          productItemType_id ? (
                          <label>Input Product </label>
                        ) : (
                          <b>&nbsp;</b>
                        )}
                        {productTypeConstModel.finishProductId ==
                          productItemType_id ||
                        productTypeConstModel.seedProductId ==
                          productItemType_id ? (
                          <select
                            id="inputProductId"
                            className="form-control"
                            required
                            ref={(el) =>
                              (frmRef.current["inputProductId"] = el)
                            }
                            value={inputProductId}
                            onChange={(e) => {
                              var inputproduct =
                                e.target.options[e.target.selectedIndex].text;
                              var packagingProduct = packagingProductName;

                              setinputProductName(inputproduct);
                              setinputProductId(e.target.value);

                              frmRef.current.productName.value =
                                packagingProduct + " " + inputproduct;
                            }}
                          >
                            <option value="">Select Input Product</option>
                            {inputProductData &&
                              inputProductData.map((x) => (
                                <option
                                  key={x.productId}
                                  product-id={x.productId}
                                  value={x.productId}
                                >
                                  {x.productName}
                                </option>
                              ))}
                          </select>
                        ) : (
                          <b>&nbsp;</b>
                        )}
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        {productTypeConstModel.finishProductId ==
                          productItemType_id ||
                        productTypeConstModel.packagingProductId ==
                          productItemType_id ? (
                          <div>
                            <label> Pack Size </label>
                            <input
                              type="number"
                              id="packSize"
                              step="0.01"
                              required
                              className="form-control"
                              ref={(el) => (frmRef.current["packSize"] = el)}
                              autoComplete="off"
                            />
                          </div>
                        ) : (
                          <b>&nbsp;</b>
                        )}
                      </div>
                    </div>

                    <div className="col-md-2">
                      <div className="form-group">
                        {productTypeConstModel.finishProductId ==
                          productItemType_id ||
                        productTypeConstModel.packagingProductId ==
                          productItemType_id ? (
                          <div>
                            <label> Pack Size Unit </label>
                            <select
                              id="unitId"
                              className="form-control"
                              ref={(el) => (frmRef.current["unitId"] = el)}
                              value={packSizeUnitId}
                              required
                              onChange={(e) => {
                                var unitName =
                                  e.target.options[e.target.selectedIndex].text;

                                setpackSizeUnitId(e.target.value);
                              }}
                            >
                              <option value="">Select Unit</option>
                              {unitFilterList &&
                                unitFilterList.map((x) => (
                                  <option
                                    key={x.unitId}
                                    unit-id={x.unitId}
                                    value={x.unitId}
                                  >
                                    {x.unitAbbreviation}
                                  </option>
                                ))}
                            </select>
                          </div>
                        ) : (
                          <b>&nbsp;</b>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Unit </label>

                        <select
                          id="unitId"
                          className="form-control"
                          ref={(el) => (frmRef.current["unitId"] = el)}
                          value={unitId}
                          required
                          onChange={(e) => {
                            var unitName =
                              e.target.options[e.target.selectedIndex].text;

                            setminimumQtyText(
                              "Minimum Notifier Quantity (" + unitName + ")"
                            );
                            setUnitId(e.target.value);
                          }}
                        >
                          <option value="">Select Unit</option>
                          {unitFilterList &&
                            unitFilterList.map((x) => (
                              <option
                                key={x.unitId}
                                unit-id={x.unitId}
                                value={x.unitId}
                              >
                                {x.unitAbbreviation}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Minimum Notifier Quantity </label>
                        <input
                          type="text"
                          id="minimumQty"
                          required
                          className="form-control"
                          ref={(el) => (frmRef.current["minimumQty"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row text-center">
                    <div className="col-md-12">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default ProductForm;
